import React, { useCallback, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import LayoutDashboard from 'app/private/layout';
import { pendingTasks as types } from '../../../../types';
import MaterialTable from 'components/table';
import { Root } from './index.styled';
import useGetPendingTasks from './hooks/use-get-pending-tasks';
import columns from './index.columns';
import DialogApprove from './dialogs/approve';
import DialogReject from './dialogs/reject';
import useCurrentSessionData from '../../../../hooks/use-current-session-data';
import useAppBarTitle from 'hooks/use-app-bar-title';

const pageTitle = 'Pending Tasks';

const PendingTasks = () => {
    useAppBarTitle(pageTitle);
    const { data, isLoading, refetch } = useGetPendingTasks();
    const [curData, setCurData] = useState<types.TComplaints>();
    const [isApproveDialogOpen, setApproveDialogOpen] =
        useState<boolean>(false);
    const [isRejectDialogOpen, setRejectDialogOpen] = useState<boolean>(false);
    const currentSessionData = useCurrentSessionData();
    const handleOnSuccessMutation = useCallback(() => {
        refetch();
    }, [refetch]);

    const handleOnApprove = useCallback((rowData) => {
        setCurData(rowData);
        setApproveDialogOpen(true);
    }, []);
    const handleOnReject = useCallback((rowData) => {
        setCurData(rowData);
        setRejectDialogOpen(true);
    }, []);

    const columnsList = useMemo(
        () =>
            columns({
                onApprove: handleOnApprove,
                onReject: handleOnReject,
                currentSessionData: currentSessionData,
            }),
        [],
    );

    return (
        <>
            <LayoutDashboard>
                <Root>
                    <MaterialTable<types.TPendingTasks>
                        data={data}
                        columns={columnsList}
                        isLoading={isLoading}
                    />
                </Root>
            </LayoutDashboard>
            {curData && (
                <>
                    <DialogApprove
                        data={curData}
                        isDialogOpen={isApproveDialogOpen}
                        setIsDialogOpen={setApproveDialogOpen}
                        asyncStatesHandlers={{
                            onSuccess: () => {
                                toast.success('Pending task approved');
                                handleOnSuccessMutation();
                            },
                            onError: (e) => {
                                toast.error(`Error: ${e}`);
                                handleOnSuccessMutation();
                            },
                        }}
                    />
                    <DialogReject
                        data={curData}
                        isDialogOpen={isRejectDialogOpen}
                        setIsDialogOpen={setRejectDialogOpen}
                        asyncStatesHandlers={{
                            onSuccess: () => {
                                toast.success('Pending task rejected');
                                handleOnSuccessMutation();
                            },
                            onError: (e) => {
                                toast.error(`Error: ${e}`);
                                handleOnSuccessMutation();
                            },
                        }}
                    />
                </>
            )}
        </>
    );
};

export default PendingTasks;
